/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as global from "../../../js/global";
import * as helper from "../../../js/helper";
import full_loading from "../../components/full-loading.vue";
import Datepicker from "../../../js/vuejs-datepicker.min.js";
import search_filters_modal from "../../modal/search-filters-modal.vue";
import filter_tablets_component from "../../components/filter-tablets-component.vue";
const __vue_script__ = {
  components: {
    full_loading: full_loading,
    Datepicker: Datepicker,
    search_filters_modal: search_filters_modal,
    filter_tablets_component: filter_tablets_component,
  },
  name: "deals-list",
  props: {},
  data() {
    return {
      global,
      helper,
      frappe,
      search_filters: localStorage.occupied_deals_search_filters
        ? JSON.parse(localStorage.occupied_deals_search_filters)
        : global.search_filters,
      is_loading: false,
      is_ready: false,
      deals: [],
      selected_deal: null,
      reason: null,
      ended_at: null,
      page: 0,
      end_of_page: false,
      sort_by: "creation",
      order: "DESC",
    };
  },
  mounted() {
    global.emitter.on("load-search-again", (args) => {
      this.load_data(true);
    });
    if (!helper.isPageNew()) {
      this.check_local_storage();
    } else {
      this.load_data(true);
    }
    window.addEventListener("scroll", this.handleScroll);
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    check_local_storage: async function () {
      this.page = (await localStorage.occupied_deals_page)
        ? localStorage.occupied_deals_page
        : 0;
      this.end_of_page =
        localStorage.occupied_deals_end_of_page == 1 ? true : false;
      this.deals = localStorage.occupied_deals_records
        ? JSON.parse(localStorage.occupied_deals_records)
        : [];
      for (let index = 0; index < this.deals.length; index++) {
        this.deals[index]["next"] = helper.toMomentObj(
          this.deals[index]["next"]
        );
      }
      this.$forceUpdate();
    },
    reset: function () {
      this.selected_deal = null;
      this.reason = null;
    },
    load_data: async function (reload = false) {
      if (this.is_loading) return;
      if (reload) {
        this.page = 0;
        this.end_of_page = false;
        while (this.deals.length > 0) {
          this.deals.pop();
        }
      }
      if (this.end_of_page) return;
      global.emitter.emit("show-full-loading");
      this.is_loading = true;
      try {
        let params = {
          filters: JSON.stringify(this.search_filters),
          page: this.page,
        };
        let url = "/api/method/maalek.api.occupied_properties";
        let res = await $.ajax({
          url: url,
          type: "GET",
          data: params,
        });
        if (res.message.length > 0) {
          for (let index = 0; index < res.message.length; index++) {
            res.message[index]["creation"] = new Date(
              res.message[index]["creation"]
            );
            res.message[index]["start"] = new Date(res.message[index]["start"]);
            res.message[index]["end"] = helper.toMomentObj(
              res.message[index]["end"]
            );
            res.message[index]["next"] = helper.toMomentObj(
              res.message[index]["next"]
            );
            res.message[index]["expanded"] = false;
            this.deals.push(res.message[index]);
          }
          this.page++;
        } else {
          this.end_of_page = 1;
        }

        localStorage.occupied_deals_records = JSON.stringify(this.deals);
        localStorage.occupied_deals_search_filters = JSON.stringify(
          this.search_filters
        );
        localStorage.occupied_deals_page = this.page;
        localStorage.occupied_deals_end_of_page = this.end_of_page ? 1 : 0;
      } catch (e) {
        helper.showException(e);
      }
      this.is_loading = false;
      this.is_ready = true;
      global.emitter.emit("hide-full-loading");
      global.refresh_tooltips();
    },
    openModal: function (elementID) {
      $(elementID).modal("show");
    },
    closeModal: function (elementID) {
      $(elementID).modal("hide");
    },
    handleScroll: function () {
      if (this.end_of_page) {
        window.removeEventListener("scroll", this.handleScroll);
      }
      if (this.loading || this.end_of_page) return;
      let pagination_component = this.$refs["pagination_component"];
      if (
        pagination_component.getBoundingClientRect().bottom < window.innerHeight
      ) {
        this.load_data();
      }
    },
    showModal: async function(element_id){
        $(element_id).modal("show");
    },
  },
  computed: {},
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "pagination_component" },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-end mb-4" },
        [
          _c("filter_tablets_component", {
            attrs: { search_filters_prop: _vm.search_filters }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn-toolbar",
              attrs: {
                role: "toolbar",
                "aria-label": "Toolbar with button groups"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "btn-group",
                  attrs: { role: "group", "aria-label": "Third group" }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: {
                        type: "button",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#searchFiltersModal"
                      }
                    },
                    [
                      _c("i", { staticClass: "fa-solid fa-sliders" }),
                      _vm._v(
                        " " + _vm._s(_vm.helper.t("Filters")) + "\n        "
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.is_loading && _vm.is_ready && _vm.deals.length == 0
        ? _c("h5", { staticClass: "text-center" }, [
            _vm._v(
              "\n    " + _vm._s(_vm.helper.t("No property found")) + "\n  "
            )
          ])
        : _c("table", { staticClass: "table" }, [
            _c("thead", [
              _c("tr", [
                _c("th", { attrs: { scope: "col" } }),
                _vm._v(" "),
                _c("th", { attrs: { scope: "col" } }, [
                  _vm._v(_vm._s(_vm.helper.t("ID#")))
                ]),
                _vm._v(" "),
                _c("th", { attrs: { scope: "col" } }, [
                  _vm._v(_vm._s(_vm.helper.t("Property")))
                ]),
                _vm._v(" "),
                _c("th", { attrs: { scope: "col" } }, [
                  _vm._v(_vm._s(_vm.helper.t("Owner")))
                ]),
                _vm._v(" "),
                _c("th", { attrs: { scope: "col" } }, [
                  _vm._v(_vm._s(_vm.helper.t("Contact#")))
                ]),
                _vm._v(" "),
                _c("th", { attrs: { scope: "col" } }, [
                  _vm._v(_vm._s(_vm.helper.t("Next Rent")))
                ]),
                _vm._v(" "),
                _c("th", { attrs: { scope: "col" } })
              ])
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _vm._l(_vm.deals, function(deal) {
                  return [
                    _c(
                      "tr",
                      {
                        class: deal["expanded"] ? "table-active" : "",
                        attrs: { role: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            deal["expanded"] = !deal["expanded"]
                          }
                        }
                      },
                      [
                        _c("th", {
                          staticClass: "cust-thumbnail",
                          style: {
                            "background-image":
                              "url(/" +
                              encodeURIComponent(deal["image"].substr(1)) +
                              ")"
                          }
                        }),
                        _vm._v(" "),
                        _c("td", [
                          _c("i", {
                            staticClass: "fa-solid",
                            class: deal["expanded"]
                              ? "fa-caret-up"
                              : "fa-caret-down"
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(deal["deal_name"]) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(deal["property"]))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(deal["deal_from_full_name"]))]),
                        _vm._v(" "),
                        _c("td", { attrs: { scope: "row" } }, [
                          _vm._v(_vm._s("0" + deal["deal_from"].substring(4)))
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.helper.toMomentStringTranslationFromNow(
                                  deal["next"].fromNow()
                                )
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "bg-white" }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  _vm.global.emitter.emit("select-deal", deal)
                                  _vm.showModal("#maintenanceRequestModal")
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "fa-solid fa-xl fa-screwdriver-wrench",
                                attrs: {
                                  "data-bs-toggle": "tooltip",
                                  "data-bs-placement": "top",
                                  title: _vm.helper.t("Maintenance Request")
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    deal["expanded"]
                      ? _c("tr", { staticClass: "table-info" }, [
                          _c("td", { attrs: { colspan: "8" } }, [
                            _c("h5", [
                              _vm._v(_vm._s(_vm.helper.t("Deal Details")))
                            ]),
                            _vm._v(" "),
                            _c("table", { staticClass: "table" }, [
                              _c("tr", [
                                _c("td", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-start"
                                    },
                                    [
                                      _c("div", { staticClass: "pe-2" }, [
                                        _vm._v(_vm._s(_vm.helper.t("Date:")))
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { attrs: { dir: "ltr" } }, [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              deal["creation"].getDate() +
                                                "-" +
                                                _vm.global.global_params.months[
                                                  deal["creation"].getMonth()
                                                ] +
                                                "-" +
                                                deal["creation"].getFullYear()
                                            )
                                          )
                                        ])
                                      ])
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-start"
                                    },
                                    [
                                      _c("div", { staticClass: "pe-2" }, [
                                        _vm._v(
                                          _vm._s(_vm.helper.t("Next Rent:"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { attrs: { dir: "ltr" } }, [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              deal["next"].format("DD-MMM-YYYY")
                                            )
                                          )
                                        ])
                                      ])
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-start"
                                    },
                                    [
                                      _c("div", { staticClass: "pe-2" }, [
                                        _vm._v(
                                          _vm._s(_vm.helper.t("Ending At:"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { attrs: { dir: "ltr" } }, [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              deal["end"].format("DD-MMM-YYYY")
                                            )
                                          )
                                        ])
                                      ])
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                deal["ad_type"] == "Rent"
                                  ? _c("td", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.helper.t("Rent Type:")) +
                                          "\n                  "
                                      ),
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.helper.t(deal["deal_rent_type"])
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                deal["ad_type"] == "Rent" && deal["document"]
                                  ? _c("td", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-start"
                                        },
                                        [
                                          _c("div", { staticClass: "pe-2" }, [
                                            _vm._v(
                                              _vm._s(_vm.helper.t("Contract:"))
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm._m(0, true)
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ])
                          ])
                        ])
                      : _vm._e()
                  ]
                })
              ],
              2
            )
          ]),
      _vm._v(" "),
      _c("search_filters_modal", {
        attrs: {
          for_map_search: false,
          hidden_fields: ["ad_type"],
          search_filters_prop: _vm.search_filters
        }
      })
    ],
    1
  )
}
var __vue_staticRenderFns__ = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { dir: "ltr" } }, [
      _c("i", { staticClass: "fa-solid fa-xl fa-file-contract" })
    ])
  }
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-5d2eaa4f_0", { source: "\n.modal-content {\r\n  overflow: visible !important;\n}\n.modal-body {\r\n  overflow: unset !important;\n}\r\n", map: {"version":3,"sources":["../maalek/maalek/public/vue/widgets/account/occupied-properties-widget.vue"],"names":[],"mappings":";AA4SA;EACA,4BAAA;AACA;AACA;EACA,0BAAA;AACA","file":"occupied-properties-widget.vue","sourcesContent":["<template>\r\n  <div ref=\"pagination_component\">\r\n    <div class=\"d-flex justify-content-end mb-4\">\r\n      <filter_tablets_component :search_filters_prop=\"search_filters\">\r\n      </filter_tablets_component>\r\n      <div\r\n        class=\"btn-toolbar\"\r\n        role=\"toolbar\"\r\n        aria-label=\"Toolbar with button groups\"\r\n      >\r\n        <div class=\"btn-group\" role=\"group\" aria-label=\"Third group\">\r\n          <button\r\n            type=\"button\"\r\n            class=\"btn btn-outline-secondary\"\r\n            data-bs-toggle=\"modal\"\r\n            data-bs-target=\"#searchFiltersModal\"\r\n          >\r\n            <i class=\"fa-solid fa-sliders\"></i> {{ helper.t(\"Filters\") }}\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <h5 v-if=\"!is_loading && is_ready && deals.length == 0\" class=\"text-center\">\r\n      {{ helper.t(\"No property found\") }}\r\n    </h5>\r\n    <table v-else class=\"table\">\r\n      <thead>\r\n        <tr>\r\n          <th scope=\"col\"></th>\r\n          <th scope=\"col\">{{ helper.t(\"ID#\") }}</th>\r\n          <th scope=\"col\">{{ helper.t(\"Property\") }}</th>\r\n          <th scope=\"col\">{{ helper.t(\"Owner\") }}</th>\r\n          <th scope=\"col\">{{ helper.t(\"Contact#\") }}</th>\r\n          <th scope=\"col\">{{ helper.t(\"Next Rent\") }}</th>\r\n          <th scope=\"col\"></th>\r\n        </tr>\r\n      </thead>\r\n      <tbody>\r\n        <template v-for=\"deal in deals\">\r\n          <tr\r\n            :class=\"deal['expanded'] ? 'table-active' : ''\"\r\n            @click.prevent=\"deal['expanded'] = !deal['expanded']\"\r\n            role=\"button\"\r\n          >\r\n            <th\r\n              class=\"cust-thumbnail\"\r\n              :style=\"{\r\n                'background-image': `url(/${encodeURIComponent(\r\n                  deal['image'].substr(1)\r\n                )})`,\r\n              }\"\r\n            ></th>\r\n            <td>\r\n              <i\r\n                class=\"fa-solid\"\r\n                :class=\"deal['expanded'] ? 'fa-caret-up' : 'fa-caret-down'\"\r\n              ></i>\r\n              {{ deal[\"deal_name\"] }}\r\n            </td>\r\n            <td>{{ deal[\"property\"] }}</td>\r\n            <td>{{ deal[\"deal_from_full_name\"] }}</td>\r\n            <td scope=\"row\">{{ \"0\" + deal[\"deal_from\"].substring(4) }}</td>\r\n            <td>\r\n              {{\r\n                helper.toMomentStringTranslationFromNow(deal[\"next\"].fromNow())\r\n              }}\r\n            </td>\r\n            <td class=\"bg-white\">\r\n              <a\r\n                href=\"#\" @click.prevent=\"global.emitter.emit('select-deal',deal);showModal('#maintenanceRequestModal');\">\r\n                <i\r\n                  class=\"fa-solid fa-xl fa-screwdriver-wrench\"\r\n                  data-bs-toggle=\"tooltip\"\r\n                  data-bs-placement=\"top\"\r\n                  :title=\"helper.t('Maintenance Request')\"\r\n                ></i>\r\n              </a>\r\n            </td>\r\n          </tr>\r\n          <tr class=\"table-info\" v-if=\"deal['expanded']\">\r\n            <td colspan=\"8\">\r\n              <h5>{{ helper.t(\"Deal Details\") }}</h5>\r\n              <table class=\"table\">\r\n                <tr>\r\n                  <td>\r\n                    <div class=\"d-flex justify-content-start\">\r\n                      <div class=\"pe-2\">{{ helper.t(\"Date:\") }}</div>\r\n                      <div dir=\"ltr\">\r\n                        <b>{{\r\n                          deal[\"creation\"].getDate() +\r\n                          \"-\" +\r\n                          global.global_params.months[\r\n                            deal[\"creation\"].getMonth()\r\n                          ] +\r\n                          \"-\" +\r\n                          deal[\"creation\"].getFullYear()\r\n                        }}</b>\r\n                      </div>\r\n                    </div>\r\n                  </td>\r\n                  <td>\r\n                    <div class=\"d-flex justify-content-start\">\r\n                      <div class=\"pe-2\">{{ helper.t(\"Next Rent:\") }}</div>\r\n                      <div dir=\"ltr\">\r\n                        <b>{{ deal[\"next\"].format(\"DD-MMM-YYYY\") }}</b>\r\n                      </div>\r\n                    </div>\r\n                  </td>\r\n                  <td>\r\n                    <div class=\"d-flex justify-content-start\">\r\n                      <div class=\"pe-2\">{{ helper.t(\"Ending At:\") }}</div>\r\n                      <div dir=\"ltr\">\r\n                        <b>{{ deal[\"end\"].format(\"DD-MMM-YYYY\") }}</b>\r\n                      </div>\r\n                    </div>\r\n                  </td>\r\n                  <td v-if=\"deal['ad_type'] == 'Rent'\">\r\n                    {{ helper.t(\"Rent Type:\") }}\r\n                    <b>{{ helper.t(deal[\"deal_rent_type\"]) }}</b>\r\n                  </td>\r\n                  <td v-if=\"deal['ad_type'] == 'Rent' && deal['document']\">\r\n                    <div class=\"d-flex justify-content-start\">\r\n                      <div class=\"pe-2\">{{ helper.t(\"Contract:\") }}</div>\r\n                      <div dir=\"ltr\">\r\n                        <i class=\"fa-solid fa-xl fa-file-contract\"></i>\r\n                      </div>\r\n                    </div>\r\n                  </td>\r\n                </tr>\r\n              </table>\r\n            </td>\r\n          </tr>\r\n        </template>\r\n      </tbody>\r\n    </table>\r\n    <!-- Modal -->\r\n    <search_filters_modal\r\n      :for_map_search=\"false\"\r\n      :hidden_fields=\"['ad_type']\"\r\n      :search_filters_prop=\"search_filters\"\r\n    ></search_filters_modal>\r\n    <!-- Modal -->\r\n  </div>\r\n</template>\r\n\r\n<script>\r\nimport * as global from \"../../../js/global\";\r\nimport * as helper from \"../../../js/helper\";\r\nimport full_loading from \"../../components/full-loading.vue\";\r\nimport Datepicker from \"../../../js/vuejs-datepicker.min.js\";\r\nimport search_filters_modal from \"../../modal/search-filters-modal.vue\";\r\nimport filter_tablets_component from \"../../components/filter-tablets-component.vue\";\r\nexport default {\r\n  components: {\r\n    full_loading: full_loading,\r\n    Datepicker: Datepicker,\r\n    search_filters_modal: search_filters_modal,\r\n    filter_tablets_component: filter_tablets_component,\r\n  },\r\n  name: \"deals-list\",\r\n  props: {},\r\n  data() {\r\n    return {\r\n      global,\r\n      helper,\r\n      frappe,\r\n      search_filters: localStorage.occupied_deals_search_filters\r\n        ? JSON.parse(localStorage.occupied_deals_search_filters)\r\n        : global.search_filters,\r\n      is_loading: false,\r\n      is_ready: false,\r\n      deals: [],\r\n      selected_deal: null,\r\n      reason: null,\r\n      ended_at: null,\r\n      page: 0,\r\n      end_of_page: false,\r\n      sort_by: \"creation\",\r\n      order: \"DESC\",\r\n    };\r\n  },\r\n  mounted() {\r\n    global.emitter.on(\"load-search-again\", (args) => {\r\n      this.load_data(true);\r\n    });\r\n    if (!helper.isPageNew()) {\r\n      this.check_local_storage();\r\n    } else {\r\n      this.load_data(true);\r\n    }\r\n    window.addEventListener(\"scroll\", this.handleScroll);\r\n  },\r\n  unmounted() {\r\n    window.removeEventListener(\"scroll\", this.handleScroll);\r\n  },\r\n  methods: {\r\n    check_local_storage: async function () {\r\n      this.page = (await localStorage.occupied_deals_page)\r\n        ? localStorage.occupied_deals_page\r\n        : 0;\r\n      this.end_of_page =\r\n        localStorage.occupied_deals_end_of_page == 1 ? true : false;\r\n      this.deals = localStorage.occupied_deals_records\r\n        ? JSON.parse(localStorage.occupied_deals_records)\r\n        : [];\r\n      for (let index = 0; index < this.deals.length; index++) {\r\n        this.deals[index][\"next\"] = helper.toMomentObj(\r\n          this.deals[index][\"next\"]\r\n        );\r\n      }\r\n      this.$forceUpdate();\r\n    },\r\n    reset: function () {\r\n      this.selected_deal = null;\r\n      this.reason = null;\r\n    },\r\n    load_data: async function (reload = false) {\r\n      if (this.is_loading) return;\r\n      if (reload) {\r\n        this.page = 0;\r\n        this.end_of_page = false;\r\n        while (this.deals.length > 0) {\r\n          this.deals.pop();\r\n        }\r\n      }\r\n      if (this.end_of_page) return;\r\n      global.emitter.emit(\"show-full-loading\");\r\n      this.is_loading = true;\r\n      try {\r\n        let params = {\r\n          filters: JSON.stringify(this.search_filters),\r\n          page: this.page,\r\n        };\r\n        let url = \"/api/method/maalek.api.occupied_properties\";\r\n        let res = await $.ajax({\r\n          url: url,\r\n          type: \"GET\",\r\n          data: params,\r\n        });\r\n        if (res.message.length > 0) {\r\n          for (let index = 0; index < res.message.length; index++) {\r\n            res.message[index][\"creation\"] = new Date(\r\n              res.message[index][\"creation\"]\r\n            );\r\n            res.message[index][\"start\"] = new Date(res.message[index][\"start\"]);\r\n            res.message[index][\"end\"] = helper.toMomentObj(\r\n              res.message[index][\"end\"]\r\n            );\r\n            res.message[index][\"next\"] = helper.toMomentObj(\r\n              res.message[index][\"next\"]\r\n            );\r\n            res.message[index][\"expanded\"] = false;\r\n            this.deals.push(res.message[index]);\r\n          }\r\n          this.page++;\r\n        } else {\r\n          this.end_of_page = 1;\r\n        }\r\n\r\n        localStorage.occupied_deals_records = JSON.stringify(this.deals);\r\n        localStorage.occupied_deals_search_filters = JSON.stringify(\r\n          this.search_filters\r\n        );\r\n        localStorage.occupied_deals_page = this.page;\r\n        localStorage.occupied_deals_end_of_page = this.end_of_page ? 1 : 0;\r\n      } catch (e) {\r\n        helper.showException(e);\r\n      }\r\n      this.is_loading = false;\r\n      this.is_ready = true;\r\n      global.emitter.emit(\"hide-full-loading\");\r\n      global.refresh_tooltips();\r\n    },\r\n    openModal: function (elementID) {\r\n      $(elementID).modal(\"show\");\r\n    },\r\n    closeModal: function (elementID) {\r\n      $(elementID).modal(\"hide\");\r\n    },\r\n    handleScroll: function () {\r\n      if (this.end_of_page) {\r\n        window.removeEventListener(\"scroll\", this.handleScroll);\r\n      }\r\n      if (this.loading || this.end_of_page) return;\r\n      let pagination_component = this.$refs[\"pagination_component\"];\r\n      if (\r\n        pagination_component.getBoundingClientRect().bottom < window.innerHeight\r\n      ) {\r\n        this.load_data();\r\n      }\r\n    },\r\n    showModal: async function(element_id){\r\n        $(element_id).modal(\"show\");\r\n    },\r\n  },\r\n  computed: {},\r\n};\r\n</script>\r\n\r\n<style>\r\n.modal-content {\r\n  overflow: visible !important;\r\n}\r\n.modal-body {\r\n  overflow: unset !important;\r\n}\r\n</style>\r\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/widgets/account/occupied-properties-widget.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__